import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';

import {
  BehaviorSubject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
  of,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
} from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-upload-documents-form',
  templateUrl: './update-upload-documents-form.component.html',
  styleUrl: './update-upload-documents-form.component.css'
})


export class UpdateUploadDocumentsFormComponent implements OnInit {
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();
  loadingSequence: boolean = false;
  eventUpdationForm: FormGroup;
  eventId: any;
  uploadError: string | null = null;
  fileErrors: { typeError: boolean; sizeError: boolean } = {
    typeError: false,
    sizeError: false,
  };
  removedocumentuploadError: string | null = null;
  uploadAttError: string | null = null;
  uploadOtherError: string | null = null;
  result: any[] = [];
  data: any = {};

  eventGuid: any;

  uploadedDocuments: any[] = [];

  eventPhotoList: any[] = [
    {
      documentName: '',
      oldFileName: ''
    }
  ];

  attendanceList: any[] = [
    {
      documentName: '',
      oldFileName: ''
    }
  ];

  otherDocumentsList: any[] = [
    {
      documentName: '',
      oldFileName: ''
    }
  ];

  UniqueEventId: string = '';
  uniqueEventId: any;
  isSubmitting = false;
  selectedItems: any[] = []; // To store selected items
  document: { name: string; file: File | null }[] = [];
  attendanc: { name: string; file: File | null }[] = [];
  otherDocumentsData: { name: string; file: File | null }[] = [];
  isSubmitted = false;

  DocumentDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination = {
    UniqueEventId: '',

    PageNumber: 1,
    PageSize: 20,
    SortColumn: '',
    SortDirection: '',
    SearchTerm: '',
    SearchCol: '',
  };
  dataSource!: MatTableDataSource<IAEventDocumentDetails>;
  displayedColumns: string[] = [
    'SrNo',
    'DocumentType',
    'CreatedDate',
    'DocumentName',
    'Download',
    'Remove',
  ];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  // 🟢 कंस्ट्रक्टरच्या आत फॉर्म इनिशियलाइज केल्यामुळे 'undefined fb' चा एरर निघून जाईल
  constructor(
    private apiService: ApiService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
  ) {
    this.eventUpdationForm = this.fb.group({
      documents: this.fb.array([this.createDocument()]),
      attendance: this.fb.array([this.createAttendanceDocument()]),
      otherDocuments: this.fb.array([this.createOtherDocument()]),
    });
  }

  form1 = new FormGroup({
    searchControl: new FormControl('', [
      Validators.pattern(this.commonService.searchFilter),
    ]),
  });

  get f() {
    return this.eventUpdationForm.controls;
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.eventId = params['eventid'];
    });
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;

    this.eventGuid =
      this.route.snapshot.paramMap.get('id');

    console.log(this.eventGuid);

    this.getUploadedDocuments();

  }

  ngAfterViewInit() {
    this.loadEventIADocemntDetails();
  }

  removeDocument(index: number): void {
    if (this.documents.length === 1) {
      this.removedocumentuploadError = 'At least 1 record must be present';
      return;
    }

    this.documents.removeAt(index);

    if (this.removedocumentuploadError && this.documents.length < 5) {
      this.removedocumentuploadError = '';
    }
  }


  removeOtherDocument(index: number): void {
    if (this.otherDocuments.length === 1) {
      this.uploadOtherError = 'At least 1 record must be present';
      return;
    }

    this.otherDocuments.removeAt(index);

    if (this.uploadOtherError && this.otherDocuments.length < 5) {
      this.uploadOtherError = '';
    }
  }
  removeAttendanceDocument(index: number): void {
    if (this.attendance.length === 1) {
      this.uploadAttError = 'At least 1 record must be present';
      return;
    }

    this.attendance.removeAt(index);
    if (this.uploadAttError && this.attendance.length < 5) {
      this.uploadAttError = '';
    }
  }

  createDocument(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      file: [null, Validators.required],
      filePath: [null]
    });
  }

  createAttendanceDocument(): FormGroup {
    return this.fb.group({
      docAttendanceName: ['', Validators.required],
      file: [null, Validators.required],
      filePath: [null]
    });
  }

  createOtherDocument(): FormGroup {
    return this.fb.group({
      documentName: ['', Validators.required],
      file: [null, Validators.required],
      filePath: [null]
    });
  }

  get documents(): FormArray {
    return this.eventUpdationForm.get('documents') as FormArray;
  }

  get attendance(): FormArray {
    return this.eventUpdationForm.get('attendance') as FormArray;
  }

  get otherDocuments(): FormArray {
    return this.eventUpdationForm.get('otherDocuments') as FormArray;
  }

  addMoreDocuments(): void {
    this.removedocumentuploadError = '';

    if (this.documents.length < 5) {
      this.documents.push(this.createDocument());
    } else {
      this.uploadError = 'You can only add a maximum of 5 documents.'; // Optional error message
    }
  }

  addMoreAttendanceDocuments(): void {
    this.uploadAttError = '';

    if (this.attendance.length < 5) {
      this.attendance.push(this.createAttendanceDocument());
    } else {
      this.uploadAttError = 'You can only add a maximum of 5 documents.'; // Optional error message
    }
  }

  addMoreOtherDocuments(): void {
    this.uploadOtherError = '';

    if (this.otherDocuments.length < 5) {
      this.otherDocuments.push(this.createOtherDocument());
    } else {
      this.uploadOtherError =
        'You can only add a maximum of 5 documents.';
    }
  }

  // 🟢 १. मुख्य फोटो फाईल चेंज
  // onFileChange(event: any, index: number): void {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const docGroup = this.documents.at(index) as FormGroup;

  //   // फॉर्म कंट्रोलमध्ये मूळ फाईल ऑब्जेक्ट सेट करणे
  //   docGroup.get('file')?.setValue(file);
  //   docGroup.get('file')?.markAsTouched();

  //   // जर डॉक्युमेंटचे नाव रिकामे असेल तर फाईलचे नाव देणे
  //   if (!docGroup.get('name')?.value) {
  //     docGroup.get('name')?.setValue(file.name.split('.')[0]);
  //   }

  //   console.log(`File selected at documents[${index}]:`, file.name);
  // }

  onFileChange(event: any, index: number): void {
  const file = event.target.files[0];
  if (!file) return;

  const docGroup = this.documents.at(index) as FormGroup;

  // File size validation (5 MB)
  if (file.size > 5 * 1024 * 1024) {

    this.toastrService.error(
      'File size should be less than 5 MB',
      'File Upload Error'
    );

    // Reset form controls
    docGroup.get('file')?.reset();
    docGroup.get('name')?.reset();

    // Clear file input
    event.target.value = '';

    return;
  }

  // Set file only after validation passes
  docGroup.get('file')?.setValue(file);
  docGroup.get('file')?.markAsTouched();

  // Auto-fill document name if empty
  // if (!docGroup.get('name')?.value) {
  //   docGroup.get('name')?.setValue(file.name.split('.')[0]);
  // }

  console.log(`File selected at documents[${index}]:`, file.name);
}

  // 🟢 २. अटेंडन्स फाईल चेंज
onAttendanceFileChange(event: any, index: number): void {
  const file = event.target.files[0];
  if (!file) return;

  const docGroup = this.attendance.at(index) as FormGroup;


  // File size validation
  if (file.size > 5 * 1024 * 1024) {
    
    this.toastrService.error(
    'File size should be less than 5 MB',
    'File Upload Error'
  );

    // Reset form controls
    docGroup.get('file')?.reset();
    docGroup.get('docAttendanceName')?.reset();

    // Clear file input
    event.target.value = '';

    return;
  }


  // Set file only after validation passes
  docGroup.get('file')?.setValue(file);
  docGroup.get('file')?.markAsTouched();

  // if (!docGroup.get('docAttendanceName')?.value) {
  //   docGroup.get('docAttendanceName')?.setValue(file.name.split('.')[0]);
  // }

  console.log(`File selected at attendance[${index}]:`, file.name);
}

  // 🟢 ३. इतर डॉक्युमेंट्स फाईल चेंज
  // onOtherDocumentFileChange(event: any, index: number): void {
  //   const file = event.target.files[0];
  //   if (!file) return;

  //   const docGroup = this.otherDocuments.at(index) as FormGroup;

  //   // फॉर्म कंट्रोलमध्ये मूळ फाईल ऑब्जेक्ट सेट करणे
  //   docGroup.get('file')?.setValue(file);
  //   docGroup.get('file')?.markAsTouched();

  //   if (!docGroup.get('documentName')?.value) {
  //     docGroup.get('documentName')?.setValue(file.name.split('.')[0]);
  //   }

  //   console.log(`File selected at otherDocuments[${index}]:`, file.name);
  // }

  onOtherDocumentFileChange(event: any, index: number): void {
  const file = event.target.files[0];
  if (!file) return;

  const docGroup = this.otherDocuments.at(index) as FormGroup;

  // File size validation (10 MB)
  if (file.size > 5 * 1024 * 1024) {

    this.toastrService.error(
      'File size should be less than 5 MB',
      'File Upload Error'
    );

    // Reset form controls
    docGroup.get('file')?.reset();
    docGroup.get('documentName')?.reset();

    // Clear file input
    event.target.value = '';

    return;
  }

  // Set file only after validation passes
  docGroup.get('file')?.setValue(file);
  docGroup.get('file')?.markAsTouched();

  // Auto-fill document name if empty
  // if (!docGroup.get('documentName')?.value) {
  //   docGroup.get('documentName')?.setValue(file.name.split('.')[0]);
  // }

  console.log(`File selected at otherDocuments[${index}]:`, file.name);
}
  // onSubmit() {
  //   this.loadingSequence = true;

  //   if (this.eventUpdationForm.invalid) {
  //     this.eventUpdationForm.markAllAsTouched();
  //     this.loadingSequence = false;
  //     return;
  //   }
  //   this.isSubmitting = true;
  //   if (this.eventUpdationForm.valid) {
  //     const formData = new FormData();

  //     const documents = this.documents.controls.map((docControl: any) => ({
  //       name: docControl.get('name')?.value,
  //       file: docControl.get('file')?.value, // This will be the file object (PDF)
  //     }));
  //     this.document = documents;

  //     const attandence = this.attendance.controls.map((docControl: any) => ({
  //       name: docControl.get('docAttendanceName')?.value,
  //       file: docControl.get('file')?.value, // This will be the file object (PDF)
  //     }));
  //     this.attendanc = attandence;

  //     this.document.forEach(
  //       (doc: { name: string; file: File | null }, index: number) => {
  //         if (doc.file) {
  //           formData.append(`documents[${index}].name`, doc.name);
  //           formData.append(
  //             `documents[${index}].file`,
  //             doc.file,
  //             doc.file.name,
  //           );
  //         }
  //       },
  //     );

  //     this.attendanc.forEach(
  //       (doc: { name: string; file: File | null }, index: number) => {
  //         if (doc.file) {
  //           formData.append(`attendances[${index}].name`, doc.name);
  //           formData.append(
  //             `attendances[${index}].file`,
  //             doc.file,
  //             doc.file.name,
  //           );
  //         }
  //       },
  //     );

  //     formData.append('UniqueEventId', this.eventId);

  //     this.apiService
  //       .postRequest(API_ENDPOINTS.IA.POSTIAEVENTUPDATE, formData)
  //       .subscribe({
  //         next: (response) => {
  //           this.toastrService.success(response.balance.message, 'Success');
  //           this.router.navigate(['/view_event']);
  //           this.loadingSequence = false;
  //         },
  //         error: (err) => {
  //           console.error('Error', err);
  //           this.router.navigate(['/view_event']);
  //           this.loadingSequence = false;
  //           this.isSubmitting = false;
  //         },
  //         complete: () => {
  //           this.router.navigate(['/view_event']);
  //           this.loadingSequence = false;
  //           this.isSubmitting = false;
  //         },
  //       });
  //   } else {
  //     this.eventUpdationForm.markAllAsTouched();
  //     return;
  //   }
  // }


  onSubmit() {
    this.loadingSequence = true;

    if (this.eventUpdationForm.invalid) {
      this.eventUpdationForm.markAllAsTouched();
      this.loadingSequence = false;
      this.toastrService.warning('Please fill all required fields.');
      return;
    }

    this.isSubmitting = true;
    const formData = new FormData();

    formData.append('UniqueEventId', this.eventGuid);
    formData.append('EventId', this.eventId || '');

    // 1️⃣ Event Photos 
    let docCounter = 0;
    this.documents.controls.forEach((control: any) => {
      const file = control.get('file')?.value;
      const name = control.get('name')?.value;
      if (file) {
        formData.append(`documents[${docCounter}].name`, name);
        formData.append(`documents[${docCounter}].file`, file, file.name);
        docCounter++;
      }
    });

    // 2️⃣ Attendance Sheets
    let attCounter = 0;
    this.attendance.controls.forEach((control: any) => {
      const file = control.get('file')?.value;
      const name = control.get('docAttendanceName')?.value;
      if (file) {
        formData.append(`attendances[${attCounter}].name`, name);
        formData.append(`attendances[${attCounter}].file`, file, file.name);
        attCounter++;
      }
    });

    // 3️⃣ Other Documents
    let otherCounter = 0;
    this.otherDocuments.controls.forEach((control: any) => {
      const file = control.get('file')?.value;
      const name = control.get('documentName')?.value;
      if (file) {
        formData.append(`otherDocuments[${otherCounter}].name`, name);
        formData.append(`otherDocuments[${otherCounter}].file`, file, file.name);
        otherCounter++;
      }
    });

    console.log('Submitting standard indexed FormData...');

    this.apiService
      .postRequest(API_ENDPOINTS.IA.POSTIAEVENTUPDATEBYID, formData)
      .subscribe({
        next: (response: any) => {
          console.log('Server Raw Response:', response);
          if (response && (response.status || response.Status || response.statusCode === 201 || response.statusCode === 200)) {

            // 🟢 यश संदेश दाखवणे
            this.toastrService.success(response.message || 'Documents updated successfully', 'Success');

            // 🟢 [मुख्य बदल]: डेटा यशस्वीरीत्या सेव्ह झाल्यावर पेज क्लोज करून लिस्ट स्क्रीनवर पाठवणे
            this.router.navigate(['/Update-Upload-Documents']);

          } else {
            alert(response?.message);
            this.toastrService.error(response?.message || 'Failed to update documents.');
          }
          this.loadingSequence = false;
          this.isSubmitting = false;
        },
        error: (err) => {
          console.error('Error during submission:', err);
          this.toastrService.error('Error while updating data.');
          this.loadingSequence = false;
          this.isSubmitting = false;
        }
      });
  }





  loadEventIADocemntDetails() {
    this.DtoPagination.UniqueEventId = this.eventGuid;
    if (!this.pagination) return;
    this.loadDataSubscription.unsubscribe();

    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(
        debounceTime(1100),
        distinctUntilChanged(),
        takeUntil(this.destroy$),
      ),
      this.pagination.page.pipe(takeUntil(this.destroy$)),
    )
      .pipe(
        filter((searchTerm) => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(
              API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST,
              this.DtoPagination,
            )
            .pipe(catchError(() => of(null)));
        }),
        map((resp) => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        }),
      )
      .subscribe((data) => {
        this.DocumentDetailsData = data;
        this.adjustPaginator();
      });
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1;
      this.DtoPagination.PageNumber = this.pageIndex + 1;
    }

    this.pagination.pageIndex = this.pageIndex;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      },
    });
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadEventIADocemntDetails();
  }
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadEventIADocemntDetails();
  }
  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');

    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadEventIADocemntDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }

  onDelete(fileType: string, fileName: string,   id: number, index: number, formArray: FormArray): void {
    const docGroup = formArray.at(index);
    const existingPath = docGroup.get('filePath')?.value;

    if (!existingPath) {
      if (formArray.length === 1) {
        this.toastrService.warning('At least 1 record must be present.');
      } else {
        formArray.removeAt(index);
      }
      return;
    }

    const confirmDelete = confirm('Are you sure you want to remove this record?');
    if (confirmDelete) {
      const payload = {
        UniqueEventId: this.eventGuid,
        DocumentType: fileType,
        DocumentName: fileName,
        id: id
      };

      console.log('Delete Payload:', payload);

      this.apiService.postRequest(API_ENDPOINTS.IA.REMOVEDOCUMENT, payload).subscribe({
        next: (resp: any) => {
          if (resp === true || (resp && (resp.status || resp.Status || resp.statusCode === 201 || resp.statusCode === 200))) {
            this.toastrService.success('Document deleted successfully.');

            if (formArray.length === 1) {
              formArray.removeAt(index);
              if (fileType === 'EventImages') formArray.push(this.createDocument());
              else if (fileType === 'EventAttendance') formArray.push(this.createAttendanceDocument());
              else formArray.push(this.createOtherDocument());
            } else {
              formArray.removeAt(index);
            }

            // 🟢 डिलीट झाल्यावर रिलोड करणे
            this.getUploadedDocuments();
          } else {
            this.toastrService.error('Error deleting document from server.');
          }
        },
        error: (error) => {
          this.toastrService.error('Error deleting document. Please try again.');
        }
      });
    }
  }


  getUploadedDocuments() {
    // 🟢 पॅरामीटरचे नाव 'UniqueEventId' (PascalCase) केले आहे, जेणेकरून बॅकएंड अचूक फिल्टर करेल
    const payload = {
      UniqueEventId: this.eventGuid
    };

    console.log('Fetching documents specifically for Event GUID:', this.eventGuid);

    this.apiService
      .getRequest(API_ENDPOINTS.IA.GETIAEVENTDOCUMENTSLIST, payload)
      .subscribe({
        next: (res: any) => {
          console.log('Filtered API Response:', res);

          if (res && res.status) {
            this.uploadedDocuments = res.data;
            console.log('Filtered Table Data for current view:', this.uploadedDocuments);

            // फक्त चालू इव्हेंटचा डेटा फॉर्ममध्ये पॅच करणे
            this.patchUploadedDocuments();
          } else {
            // जर चालू इव्हेंटसाठी एकही फाईल नसेल, तर कंट्रोल्स पूर्ण क्लिअर करून कोऱ्या ओळी ठेवणे
            this.documents.clear();
            this.attendance.clear();
            this.otherDocuments.clear();

            this.documents.push(this.createDocument());
            this.attendance.push(this.createAttendanceDocument());
            this.otherDocuments.push(this.createOtherDocument());
          }
        },
        error: (err: any) => {
          console.error('Error while fetching filtered documents:', err);
        }
      });
  }


  //patchUploadedDocuments() {

  //  if (!this.uploadedDocuments?.length) {
  //    return;
  //  }

  //  // clear default rows
  //  this.documents.clear();
  //  this.attendance.clear();
  //  this.otherDocuments.clear();

  //  this.uploadedDocuments.forEach((doc: any) => {

  //    console.log('PATCH DOC:', doc);

  //    // EVENT IMAGES
  //    if (doc.documentType === 'EventImages') {

  //      const formGroup = this.createDocument();

  //      formGroup.patchValue({

  //        name: doc.documentName

  //      });

  //      formGroup.get('file')?.clearValidators();
  //      formGroup.get('file')?.updateValueAndValidity();

  //      this.documents.push(formGroup);

  //    }

  //    // ATTENDANCE
  //    else if (doc.documentType === 'EventAttendance') {

  //      const formGroup = this.createAttendanceDocument();

  //      formGroup.patchValue({

  //        docAttendanceName: doc.documentName

  //      });

  //      formGroup.get('file')?.clearValidators();
  //      formGroup.get('file')?.updateValueAndValidity();

  //      this.attendance.push(formGroup);

  //    }
  //    // OTHER DOCUMENTS
  //    else {

  //      const formGroup = this.createOtherDocument();

  //      formGroup.patchValue({

  //        documentName: doc.documentName

  //      });

  //      formGroup.get('file')?.clearValidators();
  //      formGroup.get('file')?.updateValueAndValidity();

  //      this.otherDocuments.push(formGroup);

  //    }

  //  });

  //}


  patchUploadedDocuments() {
    // जर डेटा उपलब्ध नसेल तर कंट्रोल्स रिकामे करून कोरी ओळ देणे
    if (!this.uploadedDocuments?.length) {
      this.clearAndResetFormArrays();
      return;
    }

    // १. फॉर्म एरे आधी पूर्णपणे रिकामे करणे
    this.documents.clear();
    this.attendance.clear();
    this.otherDocuments.clear();

    let holdsImages = false;
    let holdsAttendance = false;
    let holdsOther = false;

    // २. फक्त चालू स्क्रीनच्या 'eventGuid' शी मॅच होणाराच डेटा फिल्टर करून पुश करणे
    this.uploadedDocuments.forEach((doc: any) => {
      console.log('Evaluating doc for patching:', doc);

      // कडक आयडी मॅचिंग चेक (LOWER आणि LTRIM/RTRIM चा वापर)
      const isEventMatch = doc.uniqueEventId && this.eventGuid &&
        (doc.uniqueEventId.toLowerCase().trim() === this.eventGuid.toLowerCase().trim());

      if (isEventMatch) {
        // A) EVENT IMAGES
        if (doc.documentType === 'EventImages') {
          this.documents.push(this.fb.group({
              id: [doc.id], 
            name: [doc.documentName, Validators.required],
            file: [null],
            filePath: [doc.relativePath],
            rawDocName: [doc.documentName]
          }));
          holdsImages = true;
        }
        // B) ATTENDANCE
        else if (doc.documentType === 'EventAttendance') {
          this.attendance.push(this.fb.group({
              id: [doc.id], 
            docAttendanceName: [doc.documentName, Validators.required],
            file: [null],
            filePath: [doc.relativePath],
            rawDocName: [doc.documentName]
          }));
          holdsAttendance = true;
        }
        // C) OTHER DOCUMENTS
        else if (doc.documentType === 'OtherDocuments') {
          this.otherDocuments.push(this.fb.group({
              id: [doc.id], 
            documentName: [doc.documentName, Validators.required],
            file: [null],
            filePath: [doc.relativePath],
            rawDocName: [doc.documentName]
          }));
          holdsOther = true;
        }
      }
    });

    // ३. जर फिल्टर केल्यानंतर एखाद्या विभागात एकही फाईल नसेल, तर तिथे कोरी ओळ देणे (UI सुरक्षित ठेवण्यासाठी)
    if (!holdsImages) this.documents.push(this.createDocument());
    if (!holdsAttendance) this.attendance.push(this.createAttendanceDocument());
    if (!holdsOther) this.otherDocuments.push(this.createOtherDocument());
  }

  // 🟢 कोऱ्या ओळी सेट करण्यासाठी मदतनीस फंक्शन
  clearAndResetFormArrays() {
    this.documents.clear();
    this.attendance.clear();
    this.otherDocuments.clear();
    this.documents.push(this.createDocument());
    this.attendance.push(this.createAttendanceDocument());
    this.otherDocuments.push(this.createOtherDocument());
  }




  executeSoftDelete(formArray: FormArray, index: number, docType: string, errorFlag: string) {
    const docGroup = formArray.at(index);

    const fileName = docGroup.get('rawDocName')?.value ||
      docGroup.get('documentName')?.value ||
      docGroup.get('docAttendanceName')?.value ||
      docGroup.get('name')?.value;

    const existingPath = docGroup.get('filePath')?.value;

    if (existingPath) {
      const confirmDelete = confirm(`Are you sure you want to remove the document '${fileName}'?`);
      if (!confirmDelete) return;

      // 🟢 'this.eventGuid' वापरला आहे जेणेकरून अचूक GUID (13df2aa2...) बॅकएंडला जाईल
      const jsonPayload = {
        UniqueEventId: this.eventGuid,
        DocumentName: fileName,
        DocumentType: docType
      };

      console.log('Hitting API EndPoint with payload:', jsonPayload);

      // 🟢 हा तो एपीआय कॉल आहे जो फॉर्ममधील रिमुव्ह बटनावरून ट्रिगर होईल
      this.apiService.postRequest(API_ENDPOINTS.IA.REMOVEDOCUMENT, jsonPayload).subscribe({
        next: (res: any) => {
          console.log('API Response Success:', res);

          if (res === true || (res && (res.status === true || res.Status === true || res.statusCode === 201 || res.statusCode === 200))) {
            this.toastrService.success('Document removed successfully.');

            // जर शेवटचे रेकॉर्ड असेल तर UI रिकामे न ठेवता कोरी ओळ देणे
            if (formArray.length === 1) {
              formArray.removeAt(index);
              if (docType === 'EventImages') formArray.push(this.createDocument());
              else if (docType === 'EventAttendance') formArray.push(this.createAttendanceDocument());
              else formArray.push(this.createOtherDocument());
            } else {
              formArray.removeAt(index);
            }
          } else {
            this.toastrService.error('Failed to remove document.');
          }
        },
        error: (err) => {
          console.error('API Error:', err);
          this.toastrService.error('Failed to execute remove document request.');
        }
      });
    } else {
      // नवीनच ॲड केलेली कोरी ओळ असेल तर थेट UI वरून काढा
      if (formArray.length === 1) {
        this.toastrService.warning('At least 1 record must be present.');
      } else {
        formArray.removeAt(index);
      }
    }
  }



  // viewExistingFile(path: string) {
  //   if (!path) {
  //     this.toastrService.warning('File path is empty or invalid.');
  //     return;
  //   }

  //   // 🟢 मुख्य फिक्स: सर्व बॅकस्लॅश '\' चे फॉरवर्ड स्लॅश '/' मध्ये रूपांतर करणे जेणेकरून .NET API ला अचूक पाथ मिळेल
  //   const cleanPath = path.replace(/\\/g, '/');

  //   console.log('Opening file preview for path:', cleanPath);

  //   this.apiService.downloadFile(cleanPath).subscribe({
  //     next: (blob) => {
  //       if (blob) {
  //         const url = window.URL.createObjectURL(blob);
  //         // नवीन टॅबमध्ये फाईलचा प्रिव्ह्यू उघडणे
  //         window.open(url, '_blank');
  //       } else {
  //         this.toastrService.error('File content is empty.');
  //       }
  //     },
  //     error: (err) => {
  //       console.error('File preview download error:', err);
  //       this.toastrService.error('Failed to open the file preview. Please verify file exists on server.');
  //     }
  //   });
  // }
viewExistingFile(path: string) {
  if (!path) {
    this.toastrService.warning('File path is empty or invalid.');
    return;
  }

  const cleanPath = path.replace(/\\/g, '/');

  console.log('Opening file:', cleanPath);

  this.apiService.downloadFilealltype(cleanPath).subscribe({
    next: (blob: Blob) => {

      if (!blob || blob.size === 0) {
        this.toastrService.error('File content is empty.');
        return;
      }

      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');

      // Free memory
      setTimeout(() => URL.revokeObjectURL(url), 10000);
    },
    error: (err) => {
      console.error(err);
      this.toastrService.error('Failed to open file.');
    }
  });
}

}
